import { Injectable } from '@angular/core';

@Injectable()
export class BackGroundService {

  private lastBackgroundUrl: any;

  public calculateBackground() {
    let min = 1;
    let max = 10;
    let random = Math.floor(Math.random() * (max - min + 1) + min);
    let url = 'assets/img/bg-login' + random + '.jpeg';
    this.lastBackgroundUrl = {
      background: 'url(' + url + ') no-repeat'
    };
    console.log('Calculando background', url);
    return this.lastBackgroundUrl;
  }

  public getLastBackground() {
    return (this.lastBackgroundUrl) ? this.lastBackgroundUrl : this.calculateBackground();
  }

}